import React from "react";
import {
  Card,
  CardTitle,
  Container
} from "reactstrap";
import DashboardCards from "./DashboardCards";

const Dashboard = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Card>
            <CardTitle className='fs-5 text-dark fw-bold m-2 d-flex align-items-center '>
              DASHBOARD
            </CardTitle>
          </Card>
          <Card className='p-4 shadow-none' style={{ backgroundColor: "transparent" }}>
            <DashboardCards />
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
